export default __webpack_public_path__ + "static/media/upOxxo.3866c2cd.svg";